module.exports = __webpack_public_path__ + "static/media/contac1.a10050c2.png";